<template>
  <div class="c-form-container">
		<header>
			<h3 v-if="title" class="c-form-container__title">{{ title }}</h3>
		</header>
    <div v-if="showProgressBar && (steps && steps.length)" class="c-form-container__progress">
      <progress-step-bar :currentStep="currentStep" :steps="steps"></progress-step-bar>
    </div>
    <form class="c-form-container__form">
			<section class="c-form-container__form--section">
				<slot></slot>
			</section>
    </form>

   
  </div>
</template>

<script>
import ProgressStepBar from '../../progress-step-bar/ProgressStepBar.vue';
export default {
  components: { 
		ProgressStepBar 
	},
  name: 'FormContainer',
	props: {
		id: {
      type: String
    },
    title:{
			type: String
		},
		currentStep: {
			type: Number
		},
		showProgressBar: {
			type: Boolean
		},
		steps: {
      type: Array,
    },
	}
};
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/forms/form-container/form-container.vue